<!--原卷切块-->
<template>
	<div class="drop-position" ref="config" :style="concludeWH">
		<vue-drag-resize
			class="mark-out-position"
			v-for="(rectItem, rectIndex) in rectDetail"
			:class="canDrawRect ? 'pointer-none' : 'pointer-active'"
			:key="rectIndex"
			:x="rectItem.areaMinX"
			:y="rectItem.areaMinY"
			:w="operateWidth(rectItem)"
			:h="operateHeight(rectItem)"
			:isActive="rectIndex === tempActiveArea"
			:isDraggable="rectIndex === tempActiveArea"
			:isResizable="rectIndex === tempActiveArea"
			@click.native="exitDrag"
			@dragstop="rectDragResize($event, rectIndex)"
			@resizestop="rectDragResize($event, rectIndex)"
		>
			<template>
				<div class="rect-title-wrap">
					<span class="slice-info titles" v-if="JSON.parse(rectItem.remarks).title">
						{{ JSON.parse(rectItem.remarks).title }}{{ `（${rectIndex + 1}/${rectDetail.length}）` }}
					</span>
					<i class="iconfont iconlajitong1 del-icon" @click="dropArea({ val: rectItem, state: true })"></i>
					<div class="drop-menu">
						<el-dropdown class="el-dropdown-link" @command="dropDownMenu($event, { val: rectItem, curIndex: rectIndex })">
							<i class="iconfont iconjiantou-down "></i>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="drag">拖拽选区</el-dropdown-item>
								<el-dropdown-item command="del">删除选区</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</template>
		</vue-drag-resize>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueDragResize from 'vue-drag-resize'
import isDragResize from '@/views/template-configuration/utils/mixin/is-drag-resize'
import drawRect from '@/views/template-configuration/utils/mixin/draw-rect'
import fixWH from '@/views/template-configuration/utils/mixin/fix-wh'
import fixRect from '@/views/template-configuration/utils/mixin/fix-rect'
export default {
	name: 'temp-slice',
	mixins: [isDragResize, fixWH, fixRect, drawRect],
	components: {
		VueDragResize
	},
	data() {
		return {
			//所有的大框
			rectDetail: [],
			//对大框子做缓存
			allRectDetail: [],
			query: this.$route.query,
			//类型
			emitType: 'choose'
		}
	},
	watch: {
		tempCurrentImgIndex: {
			handler() {
				this.fixCurrentTitle(this.allRectDetail)
			},
			immediate: true
		},
		tempRectSliceList: {
			handler(val) {
				this.allRectDetail = val
				this.fixCurrentTitle(val)
			},
			immediate: true
		}
	},
	computed: { ...mapGetters('examination/configation', ['tempRectSliceList']) },
	mounted() {
		const _this = this
		window.addEventListener('keydown', function(event) {
			if (event.keyCode === 17) {
				_this.isPermitDo = true
			}
		})
		window.addEventListener('keyup', function() {
			if (event.keyCode === 17) {
				_this.isPermitDo = false
			}
		})
	},
	methods: {
		fixCurrentTitle(val) {
			let rectDetail = []
			val.map(res => {
				if (res.remarks && this.tempCurrentImgIndex.curIndex + 1 === Number(JSON.parse(res.remarks).page)) {
					res.isActive = false
					res.isPermitDo = false
					res.movieState = false
					rectDetail.push(res)
				}
			})
			this.rectDetail = rectDetail
		}
	}
}
</script>

<style scoped lang="less">
@import '../utils/css/mark-point.less';
.titles {
	font-size: 40px;
}
</style>
